/**
 * AiDailyBriefing — Home dashboard hero card.
 *
 * One paragraph generated by Gemini grounded in real CAPA / deviation /
 * OOS / training / equipment / supplier / license counts pulled from
 * Postgres. Falls back to a hand-built briefing when the model is
 * unavailable.
 *
 * Annex 22 boundary: text is observational only, never prescriptive.
 */

import { useDailyBriefing } from '../../api/orgHooks';
import styles from './HomeDashboardCards.module.css';

function fmtTime(iso: string | undefined) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
}

export function AiDailyBriefing() {
  const q = useDailyBriefing();
  const d = q.data;

  if (q.isError) return null;

  return (
    <section className={styles.briefingCard} aria-label="AI daily briefing">
      <header className={styles.briefingHead}>
        <span className={styles.briefingTag}>
          <span aria-hidden>✨</span>
          AI briefing
        </span>
        {d?.generated_at_utc && (
          <span className={styles.briefingTime}>Generated {fmtTime(d.generated_at_utc)}</span>
        )}
      </header>

      <p className={styles.briefingText}>
        {q.isLoading ? <span className={styles.shimmer} /> : d?.briefing ?? '—'}
      </p>

      {d?.attention_items && d.attention_items.length > 0 && (
        <ul className={styles.attentionList}>
          {d.attention_items.slice(0, 4).map((it, idx) => (
            <li key={idx} className={styles.attentionItem}>
              <span aria-hidden>•</span> {it}
            </li>
          ))}
        </ul>
      )}

      <footer className={styles.briefingFoot}>
        <span className={styles.advisoryNote}>
          Advisory only · Source: {d?.source ?? '—'} · Annex 22 §non-prescriptive
        </span>
      </footer>
    </section>
  );
}
